var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M194 177.2l-48.7-48.5a80.1 80.1 0 0 0 16.4-48.2C161.7 36.1 125.4 0 80.9 0S0 36.1 0 80.5s36.3 80.6 80.9 80.6A79.7 79.7 0 0 0 121 150l50.1 50zM32.3 80.5a48.6 48.6 0 1 1 48.6 48.4 48.5 48.5 0 0 1-48.6-48.4z"}));
}

IconSearch.defaultProps = {"className":"icon search","viewBox":"0 0 194 200"};

module.exports = IconSearch;

IconSearch.default = IconSearch;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-search.svg
// module id = 527
// module chunks = 0